export default "__VITE_ASSET__BJklFRK___"